
import Disclaimer from "@/components/shared/Disclaimer";
import Footer from "@/components/shared/Footer";

const PrivacyPage = () => (
  <main className="min-h-screen bg-slate-50"><Disclaimer />
    <div className="container-shell py-12 max-w-3xl prose prose-slate">
      <h1>Privacy Policy</h1>
      <p>We collect information you provide when using our tools. We do not sell user data or collect protected health information.</p>
      <h2>Data Security</h2>
      <p>We implement industry-standard security measures to protect your data. Reports are retained until deleted by the user.</p>
    </div>
    <Footer />
  </main>
);


export default PrivacyPage;
